import LoaderSkeleton from "components/LoaderSkeleton";
import MemberItemRadio from "components/MemberItemRadio";
import ModalRightDialog from "components/ModalRightDialog";
import SearchInput from "components/SearchInput";

import { useUnassignedAccountControllerContext } from "../../Controller";
import { useTranslationContext } from "context/TranslationContext";

import { EAccount } from "types/index";

interface EmployeeListModalProps {
  open?: boolean;
}

export const EmployeeListModal = ({ open = false }: EmployeeListModalProps) => {
  const { t } = useTranslationContext();
  const {
    selectedEmployee,
    employeeListContainerRef,
    searchEmployeeKeyword,
    allEmployeeData,
    isLoadingEmployeeData,
    isFetchingEmployeeDataNextPage,
    onClearSearchEmployeeKeyword,
    onChangeSearchEmployee,
    onCloseSelectEmployeeMemberModal,
    onSelectEmployee,
    onOpenAssignConfirmationModal,
  } = useUnassignedAccountControllerContext();

  return (
    <ModalRightDialog
      disabledSubmit={!selectedEmployee}
      title={t("select_hs_employee")}
      open={open}
      withBack
      submitLabel={t("assign_accounts")}
      containerRef={employeeListContainerRef}
      loading={isLoadingEmployeeData}
      onBack={onCloseSelectEmployeeMemberModal}
      onClose={onCloseSelectEmployeeMemberModal}
      onSubmit={onOpenAssignConfirmationModal}
    >
      <SearchInput
        fieldClassName="bg-white"
        placeholder={t("search")}
        onSearch={onChangeSearchEmployee}
        defaultValue={searchEmployeeKeyword}
        onClearSearch={onClearSearchEmployeeKeyword}
      />
      <div className="flex gap-x-2 items-center pt-2">
        {t("employees")}
        <hr className="border-line-500 flex-1" />
      </div>
      <div className="overflow-y-auto">
        {allEmployeeData?.map((employee) => (
          <MemberItemRadio
            key={employee.idMember}
            id={employee.idMember}
            name={employee.name}
            accountType={EAccount.EMPLOYEE}
            profilePicture={employee.profilePicture}
            onSelectMember={() => onSelectEmployee(employee)}
            selectedId={selectedEmployee?.idMember}
          />
        ))}
        {isFetchingEmployeeDataNextPage && (
          <LoaderSkeleton
            number={2}
            className="w-full h-[4.8rem] rounded-xl"
            containerClassName="flex-col"
          />
        )}
      </div>
    </ModalRightDialog>
  );
};
